import { render, staticRenderFns } from "./deperdatFil.vue?vue&type=template&id=02478fcf&scoped=true&"
import script from "./deperdatFil.vue?vue&type=script&lang=js&"
export * from "./deperdatFil.vue?vue&type=script&lang=js&"
import style0 from "./deperdatFil.vue?vue&type=style&index=0&id=02478fcf&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02478fcf",
  null
  
)

export default component.exports